import React from "react";
import { useNavigate } from "react-router-dom";
import Avatar from "../../../Avatar/Avatar";
import MemberStatusChanger from "../../../Buttons/MemberStatusChanger/MemberStatusChanger";
import "./MemberRow.css";

const MemberRow = ({ statute, photoURL, name, height, userID, isAdmin }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/profile/${userID}`);
  };

  return (
    <div className="membersTableElement">
      <div className="avatar-container" onClick={handleClick} style={{ cursor: "pointer" }}>
        {isAdmin ? (
          <Avatar photoURL="/icons/star.svg" name={name} height={height * 0.66} fontHeight={height / 2} />
        ) : (
          <Avatar photoURL={photoURL} name={name} height={height} fontHeight={height / 2} />
        )}
      </div>
      <MemberStatusChanger status={statute} name={name} userUid={userID} isAdmin={isAdmin} />
    </div>
  );
};

export default MemberRow;